import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { fetchSimilar, markViewed } from '../../store/map_similar';
import { changeTab, TMapTab } from '../../store/map_tabs';
import { IOfferMapProps, OfferMap } from './map';
import { setNewbuildingMvkIsWidgetOpenAction } from '../../store/newbuilding_mvk';
import { getUserEBC } from '../../utils/tracking/get_user_ebc';
import { getPageEBC } from '../../utils/tracking/get_page_ebc';

type TStoreProps = Pick<
  IOfferMapProps,
  'activeTab' | 'agent' | 'coordinates' | 'MVKData' | 'offer' | 'similarObjects' | 'viewedIds' | 'user' | 'page'
>;

type TDispatchProps = Pick<IOfferMapProps, 'changeTab' | 'fetchSimilar' | 'markViewed' | 'openMvkWidget'>;

function mapStateToProps(state: IState): TStoreProps {
  const user = getUserEBC(state.offerData.user, state.abGroup);
  const page = getPageEBC(state.offerData.offer.id, state.offerData.breadcrumbs);
  const { offer } = state.offerData;

  return {
    activeTab: state.mapTabs.activeTab,
    agent: state.offerData.agent,
    coordinates: state.offerData.offer.geo.coordinates,
    MVKData: state.newbuildingMvk.MVKData,
    offer,
    similarObjects: state.mapSimilar,
    viewedIds: state.viewedSimilar.ids,
    user,
    page,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    changeTab: (tab: TMapTab) => dispatch(changeTab(tab)),
    fetchSimilar: (bounds: [[number, number], [number, number]]) => dispatch(fetchSimilar(bounds)),
    markViewed: (id: string) => dispatch(markViewed(id)),
    openMvkWidget: (sectionId?: number) => dispatch(setNewbuildingMvkIsWidgetOpenAction(true, sectionId)),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferMapContainer = connect<TStoreProps, TDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferMap);
